module.exports = __webpack_public_path__ + "img/mail.dc7cd9d6.svg";